/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ReferenceEnergyDemandResponse } from '../models/reference-energy-demand-response';
import { referencesControllerEnergyDemand } from '../fn/references-controller/references-controller-energy-demand';
import { ReferencesControllerEnergyDemand$Params } from '../fn/references-controller/references-controller-energy-demand';


/**
 * Represents an API resource for reference values calculated for a project.
 *     Reference values are never stored by the API, every call is forwarded to the source
 *     of the values and the result is returned as-is.
 */
@Injectable({ providedIn: 'root' })
export class ReferencesControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `referencesControllerEnergyDemand()` */
  static readonly ReferencesControllerEnergyDemandPath = '/planning-projects/v1-preview/projects/{id}/reference/energy-demand';

  /**
   * Returns the reference specific heat load and cooling load of the project building,
   *         expressed in [W/m&sup2;] units. The calculation inputs - country code, building construction year,
   *         building energy standard and building placement - are read from the stored project.
   *         Nothing is calculated or stored by this API.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referencesControllerEnergyDemand()` instead.
   *
   * This method doesn't expect any request body.
   */
  referencesControllerEnergyDemand$Response(params: ReferencesControllerEnergyDemand$Params, context?: HttpContext): Observable<StrictHttpResponse<ReferenceEnergyDemandResponse>> {
    return referencesControllerEnergyDemand(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the reference specific heat load and cooling load of the project building,
   *         expressed in [W/m&sup2;] units. The calculation inputs - country code, building construction year,
   *         building energy standard and building placement - are read from the stored project.
   *         Nothing is calculated or stored by this API.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referencesControllerEnergyDemand$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referencesControllerEnergyDemand(params: ReferencesControllerEnergyDemand$Params, context?: HttpContext): Observable<ReferenceEnergyDemandResponse> {
    return this.referencesControllerEnergyDemand$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReferenceEnergyDemandResponse>): ReferenceEnergyDemandResponse => r.body)
    );
  }

}
